var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMap(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 30.546,
    viewBox: "0 0 28 30.546",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#003d5b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-21.336)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.336)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M155.7,98.06a6.364,6.364,0,1,0-6.364-6.364A6.371,6.371,0,0,0,155.7,98.06Zm0-11.455a5.091,5.091,0,1,1-5.091,5.091A5.1,5.1,0,0,1,155.7,86.606Z",
    transform: "translate(-141.697 -80.242)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M49.285,29.659,45.467,20.75a.637.637,0,0,0-.585-.386h-2.26l.781-.778a11.455,11.455,0,1,0-16.133,0l.782.779H25.791a.637.637,0,0,0-.585.386l-3.818,8.909a.637.637,0,0,0,.585.887H48.7a.637.637,0,0,0,.585-.887Zm-24.131-18.2a10.182,10.182,0,1,1,17.351,7.229l-7.169,7.146-7.169-7.147A10.113,10.113,0,0,1,25.154,11.455ZM22.937,29.273l3.274-7.636h3.118l5.559,5.542a.635.635,0,0,0,.9,0l5.56-5.542h3.117l3.274,7.636Z",
    transform: "translate(-21.336)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMap);
export default __webpack_public_path__ + "static/media/iconMap.ccff351ed06d3d25b5e74dcd5925164d.svg";
export { ForwardRef as ReactComponent };